// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "b66fcdd95b54da636e1af1bd7d9c29719e2c1727/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};